/**
 * @generated SignedSource<<d0c1cda3b598a81d534f34e5c2605a38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksContentInterestArticle$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly sentiment?: unknown | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly types?: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "hooksContentInterestArticle";
};
export type hooksContentInterestArticle$key = {
  readonly " $data"?: hooksContentInterestArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksContentInterestArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksContentInterestArticle"
};

(node as any).hash = "7440e601a58885702cb5d00f7b1c15f7";

export default node;
